import { useEffect, useRef } from "react";
import Prism from 'prismjs';
import 'prismjs/themes/prism.css';

// Import language components
import 'prismjs/components/prism-typescript';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-jsx';
import 'prismjs/components/prism-tsx';
import 'prismjs/components/prism-bash';
import 'prismjs/components/prism-json';
import 'prismjs/components/prism-css';
import 'prismjs/components/prism-scss';
import 'prismjs/components/prism-markdown';
import { Stack, StackDirection, JustifyContent } from "@rebootui";
import CopyCode from "./CopyCode";


type CodeHighlighterProps = {
    language?: string;
    children: string;
};

const CodeHighlighter = ({ language = "tsx", children }: CodeHighlighterProps) => {
    const codeRef = useRef<HTMLElement>(null);

    useEffect(() => {
        if (codeRef.current) {
            Prism.highlightElement(codeRef.current);
        }
    }, [children]);

    return (
        <div className="snippet-highlighter">
            <Stack direction={StackDirection.Row} justifyContent={JustifyContent.End} className="bg-light">
                <CopyCode toCopy={children} />
            </Stack>
            <pre className={`bg-light p-4 language-${language}`}>
                <code ref={codeRef} className={`language-${language}`}>
                    {children}
                </code>
            </pre>
        </div>
    );
};

export default CodeHighlighter;




